import {
  createSelector,
} from 'reselect';

import {
  getResourceMappedList,
} from './resources';

import {
  sortByPosition,
  alphSortSearchOptions,
} from './utils';

const weeksSelectors = {};
export const getProgamWeeks = (programId: number, resourceType: string) => {
  if (weeksSelectors[programId]) {
    return weeksSelectors[programId];
  }
  weeksSelectors[programId] = (
    createSelector(
      [
        getResourceMappedList('programWeeks', `program_${programId}`),
        getResourceMappedList('programWorkouts', `program_${programId}`),
        getResourceMappedList(
          resourceType === 'programTemplates'
            ? 'workoutTemplates'
            : 'personalWorkouts',
          `program_${programId}`,
        ),
      ],
      (
        weeks,
        programWorkouts,
        workouts,
      ) => {
        const getWorkouts = weekId => programWorkouts
          .filter(w => w.week_id === weekId)
          .sort((a, b) => (a.position > b.position ? 1 : -1))
          .map(w => ({
            ...w,
            name: workouts.find(t => t.id === w.workout_id)?.name,
          }));

        const initial = [];
        const noWeek = getWorkouts(null);

        if (noWeek.length) {
          initial.push({
            id: -1,
            name: 'Workouts',
            workouts: noWeek,
          });
        }

        return weeks
          .sort(sortByPosition)
          .reduce((acc, week) => [
            ...acc,
            {
              ...week,
              workouts: getWorkouts(week.id),
            },
          ], initial);
      },
    )
  );
  return weeksSelectors[programId];
};

const programWorkoutsSelector = {};
export const getProgamWorkoutOptions = (personId) => {
  if (programWorkoutsSelector[personId]) {
    return programWorkoutsSelector[personId];
  }

  programWorkoutsSelector[personId] = (
    createSelector(
      [
        getResourceMappedList('workoutTemplates', 'library'),
        getResourceMappedList(
          'personalWorkouts',
          personId === 'me' ? personId : `client_${personId}`,
        ),
      ],
      (
        workoutTemplates,
        personalWorkouts,
      ) => (personId !== 'me'
        ? [
          ...workoutTemplates
            .map(
              ({ id, name }) => ({
                label: name,
                value: String(id),
              }),
            )
            .sort(alphSortSearchOptions),
          {
            label: 'Personal Workouts',
            options: personalWorkouts
              .filter(w => !w.is_for_single_exercise)
              .map(
                ({ id, name }) => ({
                  label: name,
                  value: String(id),
                  isPersonalWorkout: true,
                }),
              )
              .sort(alphSortSearchOptions),
          },
        ]
        : workoutTemplates
          .map(
            ({ id, name }) => ({
              label: name,
              value: String(id),
            }),
          )
          .sort(alphSortSearchOptions)),
    )
  );
  return programWorkoutsSelector[personId];
};
